/**
 * 运行环境判断工具
 */

/**
 * 判断当前是否运行在 CosmoSphere 客户端内（webview 嵌入）
 * UA 标识为 COSMOSphere-<版本号>，版本号动态变化，按前缀匹配即可
 * @returns {boolean}
 */
export function isCosmoSphere() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  return /cosmosphere/i.test(navigator.userAgent || '')
}
